import { getFirstRunTimeStamp } from "@/utils/user/first-run-timestamp";

const getInstallReferrer = () => {
    try {
        if (window.androidReferrerData && window.androidReferrerData.installReferrer) return window.androidReferrerData.installReferrer;
        return '-';
    } catch (error) {
        window.captureException(error);
        return '-';
    }
}

const getEnvData = (src, key) => {
    try {
        return src[key];
    } catch(error) {
        window.captureException(error);
        return "-";
    }
}

export const getUserData = () => {
    try {
        const debugData = {
            app_country: getEnvData(app.$store.state.localSettings, 'country'),
            app_currency: getEnvData(app.$store.state, 'currency'),
            app_language: getEnvData(app.$store.state, 'language'),
            app_package_name: getEnvData(window,'packageName'),
            app_version: getEnvData(window,'appVersion'),
            flutter_version: localStorage.getItem('flutterVersion') || 'not set',
            navigator_appVersion: getEnvData(navigator,'appVersion'),
            navigator_language: getEnvData(navigator,'language'),
            navigator_platform: getEnvData(navigator,'platform'),
            navigator_vendor: getEnvData(navigator,'vendor'),
            is_pro: window.IAP.hasAccessToComponent('premium'),
            first_run_ts: getFirstRunTimeStamp(),
            first_run: new Date(getFirstRunTimeStamp()).toISOString(),
            referrer: getInstallReferrer(),
            email: localStorage.getItem("userEmail") || localStorage.getItem("userEmailSend") || "-",
            deviceId: localStorage.getItem('deviceId') || '',
            url: window.location.toString(),
        };

        return debugData;
    } catch(error) {
        console.error(error);
        captureException(error);
        return '';
    }
}

export const getUserDataAsString = () => {
    const debug = getUserData();
    const rows = Object.keys(debug).map((key) => ` - ${key}: ${debug[key]}\n`);

    rows.unshift('\n```');
    rows.push('```');

    return rows.join``;
}
